export const LEGAL_ASSIGNMENT: string = `

### <!--= ++sectionIndex -->. Abtretung

Wir behalten uns das Recht vor, diese Nutzungsbedingungen sowie alle unsere Rechte und Pflichten im Rahmen dieser Nutzungsbedingungen nach eigenem Ermessen ganz oder teilweise abzutreten oder zu übertragen. Dies kann beispielsweise bei einem Eigentümerwechsel oder im Falle einer Fusion, Übernahme oder Veräußerung von Vermögenswerten der Fall sein.

Sie sind nicht berechtigt, diese Nutzungsbedingungen ganz oder teilweise abzutreten oder Ihre Rechte im Rahmen dieser Nutzungsbedingungen an Dritte zu übertragen oder unterzulizenzieren. Jeder Versuch einer Abtretung oder Übertragung unter Verletzung dieser Bedingungen ist ungültig und wirkungslos.
`;
